import { Shadows } from '@mui/material'

export const shadows = ['none', ...Array(24).fill('0px 4px 20px 0px #E7E7E9')] as Shadows
